export const styles = {
  bgWrapper: {
    backgroundColor: '#001528',
    height: '100%',
    position: 'relative',
    height: 40,
    width: '100%',
  },
  childrenWrapper: (theme) => ({
    position: 'absolute',
    width: '100%',
    maxWidth: '650px',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      pr: 'calc(100vw - 93.5%)',
      pl: 2.25,
    },
  }),
  img1: (theme) => ({
    mr: 2,
    position: 'absolute',
    width: 20,
    width: 20,
    left: 0,
    top: -2,
    [theme.breakpoints.down('xl')]: {
      width: 16,
      position: 'relative',
    },
  }),
  img2: (theme) => ({
    display: 'flex',
    alignItems: 'flex-end',
    width: 32,
    position: 'absolute',
    left: -5,
    top: -5,
    [theme.breakpoints.up('xl')]: {
      mr: -1,
      ml: -4,
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  }),

  img3: (theme) => ({
    mb: -1.5,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }),
};
